import * as angular from "angular";

export class EditRouteResourceNamePanelService {

  constructor(private $mdPanel) {
  }

  open($event, data: {options?: any, optionsWrapper?: {list?: any[], propertyRef: string}}, route, selectedId, routeName, routeColor, pickingTimeOffsetInMinutes, cb) {
    const panelPosition = this.$mdPanel.newPanelPosition()
    .relativeTo($event.target)
    .addPanelPosition(
      this.$mdPanel.xPosition.CENTER,
      this.$mdPanel.yPosition.BELOW // yPosition.BELOW
    );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
    .openFrom($event)
    .duration(200)
    .closeTo('#change-resource-btn')
    .withAnimation(this.$mdPanel.animation.FADE);

    const optionsRef = data?.options;
    const optionsWrapperRef = data?.optionsWrapper;
    // const excludeIdsRef = this.excludeOptions;
    // const ngPlaceholderRef = this.ngPlaceholder;
    // const isOrderedOptionsRef = this.isOrderedOptions;
    // const optionsPrefixRef = this.optionsPrefix;
    // const selectParamsRef = this.selectParams;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<planning-draft-edit-route-resource-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-id="ctrl.selectedIdRef" ' +
        'route="ctrl.routeRef" ' +
        'picking-time-offset-in-minutes="ctrl.pickingTimeOffsetInMinutesRef" ' +
        'route-name="ctrl.routeNameRef" ' +
        'route-color="ctrl.routeColorRef" ' +
        'options="ctrl.optionsRef" ' +
        'options-wrapper="ctrl.optionsWrapperRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</planning-draft-edit-route-resource-panel>',
      controller: function () {
        this.typeRef = 'custom';
        this.selectedIdRef = selectedId;
        this.routeRef = route;
        this.pickingTimeOffsetInMinutesRef = pickingTimeOffsetInMinutes;
        this.routeNameRef = routeName;
        this.routeColorRef = routeColor;
        this.optionsRef = optionsRef;
        this.optionsWrapperRef = optionsWrapperRef;
        // this.ngPlaceholderRef = ngPlaceholderRef;
        // this.excludeIdsRef = excludeIdsRef;
        // this.isOrderedOptionsRef = isOrderedOptionsRef;
        // this.selectParamsRef = selectParamsRef;
        // this.optionsPrefixRef = optionsPrefixRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 85,
      onChangeRouteName: (panel, updatedRouteName: string) => {
        cb(selectedId, updatedRouteName, routeColor, pickingTimeOffsetInMinutes)
        panel.destroy();
      },
      onChangeResource: (panel, updatedResourceId?: string) => {
        cb(updatedResourceId, routeName, routeColor, pickingTimeOffsetInMinutes)
        panel.destroy();
      },
      onChangePickingTimeOffsetInMinutes: (panel, updatedPickingTimeOffsetInMinutes?: number) => {
        cb(selectedId, routeName, routeColor, updatedPickingTimeOffsetInMinutes)
        panel.destroy();
      },
      onChangeRouteColor: (panel, updatedRouteColor: string) => {
        cb(selectedId, routeName, updatedRouteColor, pickingTimeOffsetInMinutes)
      },
    };

    return this.$mdPanel.open(config);
  }

}

angular
.module('bringoz.admin.commons')
.service('editRouteResourceNamePanelService', EditRouteResourceNamePanelService);

